import React from 'react';
import { Container, Typography, Box } from '@mui/material';
import SimpleImageTest from '../components/SimpleImageTest';
import OfflineImageSimple from '../components/OfflineImageSimple';
import { getBestItemImageUrl } from '../utils/imageUtils';

const ImageTest = () => {
  // Use actual item data from database for testing
  const testItem = {
    id: 99, // Real item ID from database
    user_id: 3, // Real user ID from database
    image_url: 'https://storage.googleapis.com/clutterlogix-storage/images/3_1757547417_item_PXL_20240603_191537867.jpg'
  };
  
  // Use the new optimized image function (auth will be bypassed with BYPASS_AUTH=true)
  const testImageUrl = getBestItemImageUrl(testItem);
  
  console.log('🧪 TEST: Using optimized image URL:', testImageUrl);
  
  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      <Typography variant="h4" gutterBottom>
        Image Loading Test Page
      </Typography>
      
      <Box sx={{ mb: 4 }}>
        <Typography variant="h6" gutterBottom>
          Test 1: Simple Image Test Component
        </Typography>
        <SimpleImageTest />
      </Box>
      
      <Box sx={{ mb: 4 }}>
        <Typography variant="h6" gutterBottom>
          Test 2: OfflineImageSimple Component
        </Typography>
        <OfflineImageSimple 
          src={testImageUrl}
          itemId="test-item-1"
          alt="Test Image"
          sx={{ width: 200, height: 200, border: '2px solid #ddd' }}
        />
      </Box>
      
      <Box sx={{ mb: 4 }}>
        <Typography variant="h6" gutterBottom>
          Test 3: Direct HTML img tag
        </Typography>
        <img 
          src={testImageUrl}
          alt="Direct HTML"
          style={{ 
            width: '200px', 
            height: '200px', 
            objectFit: 'cover',
            border: '2px solid #ddd'
          }}
          onLoad={() => console.log('✅ Direct HTML img loaded')}
          onError={() => console.log('❌ Direct HTML img failed')}
        />
      </Box>
      
      <Box sx={{ mb: 4 }}>
        <Typography variant="h6" gutterBottom>
          Test 4: Backend Status Check
        </Typography>
        <Typography variant="body2">
          Check console for backend connectivity tests
        </Typography>
      </Box>
    </Container>
  );
};

export default ImageTest;
